// material-ui
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import { Stack } from '@mui/material';
import { Spin } from 'antd';

// loader style
export const LoaderWrapper = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 2001,
  width: "100%",
  "& > * + *": {
    marginTop: theme.spacing(2),
  },
}));

// ==============================|| Loader ||============================== //

const Loader = () => (
  <>
    <LoaderWrapper>
      <LinearProgress color="primary" />
    </LoaderWrapper>
    <Stack width="100%" height="100%" alignItems="center" justifyContent="center">
      <Spin size="large" />
    </Stack>
  </>
);

export default Loader;
